import { jsx as t } from "react/jsx-runtime";
import { CloseIcon as o } from "../../icons/index.es.js";
import { Drawer as n, useMultiStyleConfig as a, DrawerOverlay as s, DrawerContent as w, DrawerHeader as D, DrawerBody as l, DrawerFooter as u, DrawerCloseButton as c } from "@chakra-ui/react";
const f = (e) => /* @__PURE__ */ t(n, { ...e });
function d(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(s, { sx: r.overlay, ...e });
}
function x(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(w, { sx: r.dialog, ...e });
}
function h(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(D, { sx: r.header, ...e });
}
function C(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(l, { ...e, sx: r.body });
}
function B(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(u, { ...e, sx: r.footer });
}
function $(e) {
  const r = a("DrawerTheme", e);
  return /* @__PURE__ */ t(c, { ...e, sx: r.closeButton, children: /* @__PURE__ */ t(o, { boxSize: 4 }) });
}
export {
  f as Drawer,
  C as DrawerBody,
  $ as DrawerCloseButton,
  x as DrawerContent,
  B as DrawerFooter,
  h as DrawerHeader,
  d as DrawerOverlay
};
//# sourceMappingURL=Drawer.es.js.map
